import { request } from "./client";
import { AUTH_BASE_URL } from "./axios";

const authUrl = (path) => `${AUTH_BASE_URL}${path}`;

export const requestMagicLink = (email) =>
  request(authUrl("/auth/magic-link"), {
    method: "POST",
    body: JSON.stringify({ email }),
  });

export const verifyMagicLink = (id, token) =>
  request(
    authUrl(
      `/auth/magic-link/verify?id=${encodeURIComponent(id)}&token=${encodeURIComponent(token)}`,
    ),
  );

export const googleLogin = (idToken) =>
  request(authUrl("/auth/google"), {
    method: "POST",
    body: JSON.stringify({ idToken }),
  });

export const getCurrentUser = () => request(authUrl("/auth/me"));
export const getMe = getCurrentUser;

export const connectWallet = (address) =>
  request(authUrl("/auth/wallet/connect"), {
    method: "POST",
    body: JSON.stringify({ address }),
  });

export const getPresignedUrl = ({ fileName, contentType, type }) => {
  if (
    import.meta.env.VITE_API_BASE_URL &&
    !import.meta.env.VITE_API_BASE_URL.startsWith("http")
  ) {
    throw new Error(
      "VITE_API_BASE_URL must start with https:// — check your Vercel environment variables",
    );
  }
  return request("/uploads/presigned-url", {
    method: "POST",
    body: JSON.stringify({ fileName, contentType, type }),
  });
};